import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface HotRankingProps {
  movies: Movie[];
}

export default function HotRanking({ movies }: HotRankingProps) {
  const ranked = [...movies].sort((a, b) => b.viewCount - a.viewCount).slice(0, 10);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            热门排行榜
          </h2>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer transition-colors whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-5">
          {ranked.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3]">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  title={`${movie.title} - ${movie.subtitle}`}
                />
                <div className="absolute top-2 left-2 flex items-center gap-1">
                  <span
                    className={`w-5 h-5 rounded flex items-center justify-center text-white text-xs font-bold ${
                      index < 3 ? 'bg-accent-500' : 'bg-foreground-700/60'
                    }`}
                  >
                    {index + 1}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <h3 className="mt-2 text-sm font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                <i className="ri-star-fill text-accent-500 mr-0.5"></i>
                {movie.rating}
                <span className="mx-1.5">·</span>
                {movie.subcategory}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}